/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { IViewReportApiClient } from './contracts'
import { injectable } from 'inversify'
import { ICoverageDiscoveryViewReportGrid, ICoverageDiscoveryViewReportGridResults } from '../RequestHistoryStateManager/contracts'

@injectable()
export class MockViewReportApiClient implements IViewReportApiClient {
	public viewReports: ICoverageDiscoveryViewReportGrid[] = []

	constructor() {
		for (let x = 1; x <= 20; x++) {
			this.viewReports.push({
				id: x,
				requestDate: new Date(2020, 1, 1, Math.round((Math.random() * 500) % 500), Math.round((Math.random() * 1000) % 1000), 0, 0),
				name: `Report_${x}`,
			})
		}
	}
	getReportDetailsOnCompletion() {
		const result: ICoverageDiscoveryViewReportGridResults = {
			items: this.viewReports.slice(),
			total: 0,
		}
		result.total = result.items.length
		return new Promise<ICoverageDiscoveryViewReportGridResults>(resolve => {
			setTimeout(() => resolve(result), 100)
		})
	}

	deleteSelectedReport(id: number) {
		return new Promise<void>(resolve => {
			setTimeout(() => resolve(), 100)
		})
	}
}
